import { useEffect, useState } from 'react';
import { useCmpIntContext } from './useCmpIntContext';

// Custom hook to set view according to the available device types originating from client's config
export const useCompIntDeviceView = () => {
  const { isDesktopSupported, isMobileSupported } = useCmpIntContext();
  const [view, setView] = useState<'desktop' | 'mobile'>('desktop');

  useEffect(() => {
    setView(isDesktopSupported || !isMobileSupported ? 'desktop' : 'mobile');
  }, [isDesktopSupported, isMobileSupported]);

  return [view, setView] as const;
};
